export const CLASSNAME = 'wrex-content-image-gallery';

export enum IMAGE_GALLERY_VIEW_MODE {
    mosaic = 'view-mode-mosaic',
    slideshow = 'view-mode-slideshow',
}
